import React from 'react';

export const QuestionMark = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '18px'}
    height={height ?? '18px'}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99984 15.6665C12.6817 15.6665 15.6665 12.6817 15.6665 8.99984C15.6665 5.31794 12.6817 2.33317 8.99984 2.33317C5.31794 2.33317 2.33317 5.31794 2.33317 8.99984C2.33317 12.6817 5.31794 15.6665 8.99984 15.6665ZM8.99984 17.3332C13.6022 17.3332 17.3332 13.6022 17.3332 8.99984C17.3332 4.39746 13.6022 0.666504 8.99984 0.666504C4.39746 0.666504 0.666504 4.39746 0.666504 8.99984C0.666504 13.6022 4.39746 17.3332 8.99984 17.3332ZM9.83317 13.1665C9.83317 13.6267 9.46007 13.9998 8.99984 13.9998C8.5396 13.9998 8.1665 13.6267 8.1665 13.1665C8.1665 12.7063 8.5396 12.3332 8.99984 12.3332C9.46007 12.3332 9.83317 12.7063 9.83317 13.1665ZM7.33317 8.1665C7.33317 7.5593 7.55259 7.16513 7.83472 6.91434C8.1322 6.64992 8.5524 6.49984 8.99984 6.49984C9.85568 6.49984 10.6665 7.14312 10.6665 8.1665C10.6665 9.18988 9.85568 9.83317 8.99984 9.83317C8.5396 9.83317 8.1665 10.2063 8.1665 10.6665C8.1665 11.1267 8.5396 11.4998 8.99984 11.4998C10.644 11.4998 12.3332 10.2372 12.3332 8.1665C12.3332 6.09583 10.644 4.83317 8.99984 4.83317C8.19728 4.83317 7.36748 5.09975 6.72745 5.66866C6.07209 6.25121 5.6665 7.10704 5.6665 8.1665C5.6665 8.62674 6.0396 8.99984 6.49984 8.99984C6.96007 8.99984 7.33317 8.62674 7.33317 8.1665Z"
      fill="#6B778C"
    />
  </svg>
);
